module.exports = __webpack_public_path__ + "static/img/home_foto2.c4edd5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/home_foto2.png
// module id = 15
// module chunks = 0